import { useMutation } from 'react-query'
import { api } from '../api'
import { GenerativeAIContent, GenerativeAIPart, ProjectFormEnum } from 'shared'

export const useAccompanyingReportAiMutation = () => {
  return useMutation({
    mutationFn: (values: {
      parts: GenerativeAIPart[]
      history: GenerativeAIContent[]
      projectForm: ProjectFormEnum
    }) => {
      return api.post('/accompanying-report', values)
    },
  })
}
